export const MOONBEAM_CORE_SUBGRAPH =
  'https://graph.beamswap.io/subgraphs/name/beamswap/beamex-core'
export const MOONBEAM_CANDLES_SUBGRAPH =
  'https://graph.beamswap.io/subgraphs/name/beamswap/beamex-prices'
export const MOONBEAM_STATS_SUBGRAPH =
  'https://graph.beamswap.io/subgraphs/name/beamswap/beamex-stats'
export const MOONBEAM_LEADERBOARD_SUBGRAPH =
  'https://graph.beamswap.io/subgraphs/name/beamswap/beamex-leaderboard'

export const USD_DECIMALS = 30
export const GLP_DECIMALS = 18

export const MOONBEAM_CANDLE_TOKENS = {
  BTC: '0xe57ebd2d67b462e9926e04a8e33f01cd0d64346d',
  ETH: '0xab3f0245b83feb11d15aaffefd7ad465a59817ed',
  WGLMR: '0xacc15dc74880c9944775448304b263d191c6077f',
  DOT: '0xffffffff1fcacbd218edc0eba20fc2308c778080',
  USDC: '0x931715fee2d06333043d11f658c8ce934ac61d0c',
  xcUSDT: '0xffffffffea09fb06d082fd1275cd48b191cbcd1d'
}

export const MOONBEAM_TOKEN_NAMES = {
  '0xe57ebd2d67b462e9926e04a8e33f01cd0d64346d': 'BTC',
  '0xab3f0245b83feb11d15aaffefd7ad465a59817ed': 'ETH',
  '0xacc15dc74880c9944775448304b263d191c6077f': 'WGLMR',
  '0xffffffff1fcacbd218edc0eba20fc2308c778080': 'DOT',
  '0x931715fee2d06333043d11f658c8ce934ac61d0c': 'USDC',
  '0xffffffffea09fb06d082fd1275cd48b191cbcd1d': 'xcUSDT'
}

export const MOONBEAM_TOKENS = [
  '0xe57ebd2d67b462e9926e04a8e33f01cd0d64346d',
  '0xab3f0245b83feb11d15aaffefd7ad465a59817ed',
  '0xacc15dc74880c9944775448304b263d191c6077f',
  '0xffffffff1fcacbd218edc0eba20fc2308c778080',
  '0x931715fee2d06333043d11f658c8ce934ac61d0c',
  '0xffffffffea09fb06d082fd1275cd48b191cbcd1d'
]
